export default "__VITE_ASSET__DkBhKW5r__"